<template>
  <credit-widget data-testid="personal-income-widget">
    <template slot="widget-header">
      <i-icon
        class="icon i-text-neutral-110"
        symbol="small-money-wallet-1"
        :size="16"
      ></i-icon>
      <span>{{ widgetHeadingText }}</span>
    </template>
    <template slot="widget-content">
      <div class="line">
        <i-toggle
          :toggle-value="showTransactions"
          :full-width="true"
          left-label="Transactions"
          right-label="Payslips"
          @value-update="(v) => (showTransactions = v)"
        ></i-toggle>
      </div>
      <div v-if="showTransactions" class="line">
        <span>Period Net</span>
        <credit-widget-value
          :value="transactionPeriodNet"
          :currency="true"
        ></credit-widget-value>
      </div>
      <div v-if="showTransactions" class="line">
        <span>Estimated Annual Net</span>
        <credit-widget-value
          :value="transactionAnnualNet"
          :currency="true"
        ></credit-widget-value>
      </div>
      <div v-if="showTransactions" class="line">
        <span>Count of Deposits</span>
        <credit-widget-value
          :value="transactionDepositsCount"
        ></credit-widget-value>
      </div>
      <div v-if="showTransactions" class="line">
        <span>Average Deposit Amount</span>
        <credit-widget-value
          :value="avgDepositAmount"
          :currency="true"
        ></credit-widget-value>
      </div>
      <div v-if="!showTransactions" class="line">
        <span>Period Gross</span>
        <credit-widget-value
          :value="payslipPeriodGross"
          :currency="true"
        ></credit-widget-value>
      </div>
      <div v-if="!showTransactions" class="line">
        <span>Estimated Annual Gross</span>
        <credit-widget-value
          :value="payslipAnnualGross"
          :currency="true"
        ></credit-widget-value>
      </div>
      <div v-if="!showTransactions" class="line">
        <span>Period Net</span>
        <credit-widget-value
          :value="payslipPeriodNet"
          :currency="true"
        ></credit-widget-value>
      </div>
      <div v-if="!showTransactions" class="line">
        <span>Estimated Annual Net</span>
        <credit-widget-value
          :value="payslipAnnualNet"
          :currency="true"
        ></credit-widget-value>
      </div>
    </template>
  </credit-widget>
</template>

<script>
import CreditWidget from '@/V2/credit/widgets/CreditWidget';
import CreditWidgetValue from '@/V2/credit/widgets/CreditWidgetValue';
import { iIcon, iToggle } from '@inscribe/signal';

export default {
  name: 'IncomePersonal',
  components: { CreditWidget, CreditWidgetValue, iIcon, iToggle },
  props: {
    widgetData: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      showTransactions: true,
    };
  },
  computed: {
    transactionPeriodNet() {
      return this.widgetData?.transaction_data?.period_net;
    },
    transactionAnnualNet() {
      return this.widgetData?.transaction_data?.estimated_annual_net;
    },
    transactionDepositsCount() {
      return this.widgetData?.transaction_data?.count_deposits;
    },
    avgDepositAmount() {
      return this.widgetData?.transaction_data?.average_deposit_amount;
    },
    payslipPeriodGross() {
      return this.widgetData?.payslip_data?.period_gross;
    },
    payslipPeriodNet() {
      return this.widgetData?.payslip_data?.period_net;
    },
    payslipAnnualGross() {
      return this.widgetData?.payslip_data?.estimated_annual_gross;
    },
    payslipAnnualNet() {
      return this.widgetData?.payslip_data?.estimated_annual_net;
    },
    noTransactionsReturned() {
      return (
        !this.transactionPeriodNet &&
        !this.transactionAnnualNet &&
        !this.transactionDepositsCount &&
        (this.payslipPeriodGross ||
          this.payslipPeriodNet ||
          this.payslipAnnualGross ||
          this.payslipAnnualNet)
      );
    },
    widgetHeadingText() {
      return 'Personal Income Insights';
    },
  },

  watch: {
    noTransactionsReturned: {
      handler: function (newVal) {
        if (newVal) {
          this.showTransactions = false;
        }
      },
      immediate: true,
    },
  },
};
</script>
